import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Form, Input, Button, message } from 'antd';
import { UserOutlined, LockOutlined, SafetyCertificateOutlined } from '@ant-design/icons';
import { useAuth } from '../context/AuthContext';
import { getUser } from '../utils/tokenStorage';

const Login = () => {
  const [showMfa, setShowMfa] = useState(false);
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const onFinish = async (values) => {
    setLoading(true);
    const result = await login(
      values.email,
      values.password,
      showMfa ? values.mfaCode : null
    );

    if (result.success) {
      message.success('Welcome back!');
      const user = getUser();
      if (user?.role === 'super_admin') navigate('/super-admin');
      else if (user?.role === 'owner') navigate('/owner');
      else navigate('/employee');
    } else {
      if (result.message === 'MFA code required') {
        setShowMfa(true);
        message.info('Please enter your 6-digit MFA code');
      } else {
        message.error(result.message || 'Login failed');
      }
    }
    setLoading(false);
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      padding: 24,
    }}>
      <Card
        style={{ width: '100%', maxWidth: 420, boxShadow: '0 10px 40px rgba(0,0,0,0.15)' }}
        title={<span style={{ fontSize: 22, fontWeight: 600 }}>Sign in to Hostel MS</span>}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          size="large"
        >
          <Form.Item
            name="email"
            rules={[{ required: true, message: 'Please enter your email' }, { type: 'email', message: 'Invalid email' }]}
          >
            <Input prefix={<UserOutlined />} placeholder="Email" />
          </Form.Item>
          <Form.Item
            name="password"
            rules={[{ required: true, message: 'Please enter your password' }]}
          >
            <Input.Password prefix={<LockOutlined />} placeholder="Password" />
          </Form.Item>
          {showMfa && (
            <Form.Item
              name="mfaCode"
              rules={[{ required: true, message: 'Enter 6-digit code' }, { len: 6, message: 'Code must be 6 digits' }]}
            >
              <Input prefix={<SafetyCertificateOutlined />} placeholder="MFA Code (6 digits)" maxLength={6} />
            </Form.Item>
          )}
          <Form.Item>
            <Button type="primary" htmlType="submit" block loading={loading} size="large">
              {loading ? 'Signing in...' : 'Sign in'}
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default Login;
